import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CoreApiService} from "../../../core/service/core-api.service";
import {BasicDataResponseDto, DtoReferFriend, ProfileDto, UserDocumentDto, UserPhotoDto} from "../types/user.types";
import {ApiResponseDto, DtoDeactivateAccount} from "../../../core/interfaces/core.types";
import {EndUserSignatureOverviewDto, SignatureDto} from "../../user-signatures/type/user-signatures.types";


@Injectable({ providedIn: 'root' })
export abstract class UserDocumentApiService {

  endPoint: string = "mvseu/eu/endUserDocument"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public list(): Observable<UserDocumentDto[]> {
    return this.coreApiService.get(`${this.endPoint}/list`);
  }

  public getDocumentBinary(documentId: number): Observable<string> {
    return this.coreApiService.getDocumentBinary(`${this.endPoint}/${documentId}/$`);
  }


}
